module.exports = __webpack_public_path__ + "media/icons/youtube-6151262a.png";